import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Privacy() {
  const navigate = useNavigate();
  
  const tmStyle = {
    fontSize: '0.5em',
    verticalAlign: 'super'
  };
  
  return (
    <div className="legal-page">
      <h1>Privacy Policy</h1>
      
      <section className="privacy-overview">
        <p>
          At NeuCraft<span style={tmStyle}>™</span>, your privacy matters. We only collect the information needed to process your orders and keep you informed 
		  about your purchases. We never sell or share your data with third parties, except as needed to fulfill your order (e.g., shipping carriers). Your 
		  information is stored securely and only accessible by our team.
        </p>
      </section>
      
      <section className="privacy-contact">
        <h2>Contact</h2>
        <p>
          For any questions about this policy or our privacy practices, please contact us at <a href="mailto:support@neucraft.shop">support@neucraft.shop</a>.
        </p>
      </section>
      
      <div className="productpage-actions productpage-actions-row" style={{justifyContent:'flex-start', marginTop:'80px'}}>
        <button className="card-btn productpage-btn-small" onClick={() => navigate('/')} type="button" style={{cursor:'pointer'}}>&larr; Home</button>
      </div>
    </div>
  );
}